export var tablePortalTokens = {
  fontSize: "s",
  cell: {
    padding: "12px",
    resetFirstColumnPadding: true
  },
  table: {
    marginTop: "12px",
    marginBottom: "24px",
    borderAroundTable: false
  },
  caption: {
    paddingTop: "16px",
    paddingBottom: "8px"
  },
  colors: {
    th: function th(_ref) {
      var color = _ref.color;
      return color.text.secondary.base;
    },
    td: function td(_ref2) {
      var color = _ref2.color;
      return color.text.black.base;
    },
    border: function border(_ref3) {
      var color = _ref3.color;
      return color.border.hr.base;
    },
    caption: function caption(_ref4) {
      var color = _ref4.color;
      return color.text.secondary.base;
    },
    bgHover: function bgHover(_ref5) {
      var palette = _ref5.palette;
      return palette.neutralsBlack.hex5;
    }
  },
  defaultHovered: true,
  hoverWithXOverflow: true
};